export const ORDER_STATUS_UPDATE =
    "App\\Notifications\\Order\\Status\\OrderStatusUpdateNotification";
export const ORDER_CLOSED =
    "App\\Notifications\\Order\\OrderClosedNotification";
